import React, { useState } from "react";
import useCheckPermission from "hooks/src/useCheckPermissons";
import CalendarDatePicker from "ui/components/comp-507";


const BudgetFilters = ({ filters, setFilters }) => {
  const { canRead } = useCheckPermission({ collection: "billables" });

  const [dateRange, setDateRange] = useState({
    from: filters?.startDate,
    to: filters?.endDate,
  });

  if (!canRead) return null;

  const handleDateRangeChange = (range) => {
    const from = range?.from || undefined;
    const to = range?.to || undefined;
    setDateRange({ from, to });

    const isComplete = Boolean(from && to);
    const isCleared = !from && !to;
    if (!isComplete && !isCleared) return;
    if (filters?.startDate === from && filters?.endDate === to) return;

    setFilters({ ...filters, startDate: from, endDate: to });
  };

  return (
    <div className="w-full flex gap-2">
      <CalendarDatePicker
        date={dateRange}
        setDate={handleDateRangeChange}
        placeholder="Pick a date range"
      />
    </div>
  );
};

export default BudgetFilters;
